import * as React from "react";
import WarningIcon from "@material-ui/icons/Warning";

export const ProblemenIcon = () => {
    return <WarningIcon />;
}

